import { call, put, takeLatest } from 'redux-saga/effects';
import { getLkIp } from '../../services/API';

import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getInfo() {
  const response = yield call(getLkIp);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* klIpSaga() {
  yield takeLatest(actionTypes.GET_INFO, getInfo);
  yield takeLatest(actionTypes.GET_INFO_SKIP_LOADING, getInfo);
}
